import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var copyButtonPluginKey = new PluginKey('copyButtonPlugin');